import React from 'react';

/**
 * Renders loading, empty, or content state.
 * Eliminates nested ternaries in list/table components.
 */
export function DataState({ loading, empty, emptyContent, children }) {
  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="w-6 h-6 border-2 border-foreground border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (empty) {
    return emptyContent || (
      <div className="py-12 text-center text-sm text-muted-foreground">No data found</div>
    );
  }
  return children;
}

/**
 * Table-specific loading/empty/content wrapper.
 * Returns <tr> elements for use inside <tbody>.
 */
export function TableState({ loading, empty, colSpan, emptyText = 'No data found', children }) {
  if (loading) {
    return <tr><td colSpan={colSpan} className="text-center py-12 text-muted-foreground text-sm">Loading...</td></tr>;
  }
  if (empty) {
    return <tr><td colSpan={colSpan} className="text-center py-12 text-muted-foreground text-sm">{emptyText}</td></tr>;
  }
  return <>{children}</>;
}
